import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { ReactSVG } from 'react-svg';
import ArrowRight from '@/assets/img/arrow_right.svg';
import SupportCaseIcon from '@/assets/img/support_case.svg';
import { TRACKING_TYPE } from '@/utils/constants';
import { handleRequest } from '@/utils';
import { updateDialogueInfo } from '@/utils/sessionUtils';
import { ButtonInfo, DialogueInfo, handleRedirectionBtnClick } from '@/utils/btnClickHandler';
import Badge from '@nebula/badge';
import { AgentStore } from '@/stores/agent';
import initStore, { InitStore } from '@/stores/init';
import { addObserver, removeObserver } from '@/utils/intersectionObserver';
import './style.scss';

const PREFIX = 'my-support-case';

interface SupportCase {
  total_count: number;
  update_count: number;
}

type MySupportCaseProps = {
  msgContent: string;
  support_case: SupportCase;
  nodePointId: string;
  historySessionId: string;
  listPos: number;
} & {
  agentStore: typeof AgentStore;
  initStore: typeof InitStore;
} & DialogueInfo &
ButtonInfo;

const MySupportCase = observer((props: MySupportCaseProps) => {
  const { msgContent, support_case, isHistory, historySessionId, listPos } = props;

  const trackingname = TRACKING_TYPE.MY_SUPPORT_CASE_BUTTON;
  const trackingdata = {
    chat_session_id: isHistory ? historySessionId : initStore.sessionId || '',
    updated_case: support_case.update_count > 0,
  };

  const myRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    addObserver(myRef.current);

    return () => {
      removeObserver(myRef.current);
    };
  }, []);

  const handleClick = () => {
    handleRedirectionBtnClick({ ...props }, { trackingname, trackingdata }, async () => {
      const res = await handleRequest('getSupportCaseCount', { session_id: initStore.sessionId }, { noLoading: true });
      res && updateDialogueInfo({ support_case: { ...res, total_count: support_case.total_count }}, listPos);
    });
  };

  return (
    <div
      ref={myRef}
      data-trackingname={trackingname}
      data-trackingdata={JSON.stringify(trackingdata)}
      className={PREFIX}
      onClick={handleClick}
    >
      <ReactSVG src={SupportCaseIcon} className="list-icon" />
      <div className="message-content">{msgContent}</div>
      <div className="message-control">
        <Badge count={support_case.update_count} verticalAlign="middle" />
        <ReactSVG src={ArrowRight} className="message-control__right" />
      </div>
    </div>
  );
});

export default MySupportCase;
